import type { HighCostZipCodeSchedule } from "../../hooks/react-query/backOffice/useHighCostZipCodeSchedules";

interface MockHighCostZipCodeScheduleAccount {
  accountId: number;
  accountName: string;
  accountNumber: string;
}

/** Keyed by scheduleId. */
export const mockHighCostZipCodeScheduleAccounts: Record<
  number,
  MockHighCostZipCodeScheduleAccount[]
> = {
  1: [
    {
      accountId: 101,
      accountName: "Alpha Logistics LLC",
      accountNumber: "ACC-1001",
    },
    {
      accountId: 102,
      accountName: "Beta Freight Corp",
      accountNumber: "ACC-1002",
    },
    {
      accountId: 103,
      accountName: "Gamma Shipping Inc",
      accountNumber: "ACC-1003",
    },
    {
      accountId: 104,
      accountName: "Delta Transport Co",
      accountNumber: "ACC-1004",
    },
    {
      accountId: 105,
      accountName: "Epsilon Carriers",
      accountNumber: "ACC-1005",
    },
    {
      accountId: 106,
      accountName: "Zeta Delivery Services",
      accountNumber: "ACC-1006",
    },
    {
      accountId: 107,
      accountName: "Eta Freight Solutions",
      accountNumber: "ACC-1007",
    },
    {
      accountId: 108,
      accountName: "Theta Logistics Group",
      accountNumber: "ACC-1008",
    },
  ],
  2: [
    {
      accountId: 201,
      accountName: "Regional Haulers Inc",
      accountNumber: "ACC-2001",
    },
    {
      accountId: 202,
      accountName: "Mountain Freight LLC",
      accountNumber: "ACC-2002",
    },
    {
      accountId: 203,
      accountName: "Valley Transport Co",
      accountNumber: "ACC-2003",
    },
  ],
  3: [],
  4: [],
};

export const mockHighCostZipCodeSchedules: HighCostZipCodeSchedule[] = [
  {
    id: 1,
    name: "Standard High Cost Zip Codes",
    description: "Blind Shipment Fee",
    status: "Active",
    zipCodeCount: 10,
    createdBy: "Carlos Mendez",
    createdOn: "11/5/2025",
    modifiedBy: "Carlos Mendez",
    modifiedOn: "11/5/2025",
    isGlobal: false,
  },
  {
    id: 2,
    name: "Regular High Cost Zip Codes",
    description: "Regional surcharge schedule",
    status: "Active",
    zipCodeCount: 12,
    createdBy: "Carlos Mendez",
    createdOn: "11/1/2025",
    modifiedBy: "Carlos Mendez",
    modifiedOn: "11/2/2025",
    isGlobal: false,
  },
  {
    id: 3,
    name: "Extended High Cost Zip Codes",
    description: "Extended coverage",
    status: "Inactive",
    zipCodeCount: 24,
    createdBy: "Jane Smith",
    createdOn: "10/15/2025",
    modifiedBy: "Jane Smith",
    modifiedOn: "10/20/2025",
    isGlobal: false,
  },
  {
    id: 4,
    name: "Draft High Cost Schedule",
    description: "Work in progress schedule",
    status: "Draft",
    zipCodeCount: 5,
    createdBy: "John Doe",
    createdOn: "11/10/2025",
    modifiedBy: "John Doe",
    modifiedOn: "11/10/2025",
    isGlobal: false,
  },
];
